import { render, staticRenderFns } from "./MarketplaceProductDetails.vue?vue&type=template&id=19dbb0f5"
import script from "./MarketplaceProductDetails.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductDetails.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceProductDetails.vue?vue&type=style&index=0&id=19dbb0f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports